<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3 mr-r15">
        {{settingNodeTitle}}
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper ref="warningTable" :data="dataList" :columns="warningColumns" @row-dblclick="editWarningSetting"
    :column-default="columnDefault" :show-custom-header="true" row-class-name="c-dblclick"
    :show-search-tool="showSearchTool">
      <template slot-scope="scope" slot="eventlevel-slot">
        <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
      </template>
      <template slot-scope="scope" slot="status-slot">
        <span class="state-abnormal" v-if="scope.row.applyFlag === '0'">미적용</span>
        <span v-else-if="scope.row.applyFlag === '1'">적용</span>
      </template>
    </el-table-wrapper>
    <w-warning-set-popup ref="warningSetPopup" :editRow="editRow" @reload="loadData"></w-warning-set-popup>
  </div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import CellEditingMixin from '@/mixins/table/cell-editing';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WWarningSetPopup from './popup/WarningSetPopup';

export default {
  name: 'WWarningSettingView',
  components: {
    WWarningSetPopup,
    WEventlevelCell,
  },
  mixins: [CellEditingMixin],
  props: {
    treeType: {
      type: String,
    },
    currentNode: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      dataList: [],
      editRow: null,
      settingNodeTitle: '',
      showSearchTool: false,
      warningColumns: [
        {
          prop: 'applyFlag',
          label: '적용',
          width: 100,
          sortable: true,
          scopedSlot: 'status-slot',
        },
        {
          prop: 'warningCode',
          label: '코드',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'warningDesc',
          label: '설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'threshold',
          label: '임계치',
          width: 100,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'eventJudgeTime',
          label: '측정시간(s)',
          width: 100,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'eventJudgeCount',
          label: '기준횟수',
          width: 120,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'normalizationTime',
          label: '이벤트 해지시간(s)',
          width: 150,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'eventlevelId',
          label: '이벤트레벨',
          width: 150,
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          searchable: false,
        },
      ],
    };
  },
  watch: {
    currentNode: {
      handler() {
        if (!isNil(this.currentNode)) {
          if (this.currentNode.type === 'domain' || this.currentNode.type === 'obj') {
            this.loadData();
            this.settingNodeTitle = `[${this.currentNode.label}] 경보 설정 목록`;
            this.selectedConfigTreekey = this.currentNode.treeKey;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [loadData 도메인 경보설정 / 인스턴스 경보설정을 분기하여 조회한다.]
     * @author yelim
     */
    loadData() {
      const currentDomainId = Number(this.currentNode.treeKey.split('.')[1]);
      const params = {
        domainId: currentDomainId,
      };
      if (this.currentNode.type === 'obj') {
        params.objId = this.currentNode.objId;
        params.warningType = 'objWarning';
      } else {
        params.warningType = 'domainWarning';
      }
      ApmSettingAPI.getWarningSetInfo(params).then((response) => {
        if (response.data.success) {
          this.dataList = response.data.data;
        }
      });
    },
    convertFlag(row, column, value) {
      return (!isNil(value) && value === true) ? '적용' : '미적용';
    },
    editWarningSetting(row) {
      const rowData = row;
      rowData.type = `${this.currentNode.type}Warning`;
      rowData.objId = this.currentNode.objId;
      this.editRow = cloneDeep(rowData);
      this.$refs.warningSetPopup.open();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/apm/WarningSettings/WarningSettingView.vue